'use strict';

module.exports = function isObject(x) {
	return typeof x === 'object' && x !== null;
};



//////////////////
// WEBPACK FOOTER
// ./~/is-object/index.js
// module id = 418
// module chunks = 0 1 2 3 4